// Angular
import { Injectable } from '@angular/core';
// Afidium
import { ErrorTracingService } from "libraries/service/error-tracing/error-tracing.service";
import { IGetBookingsCommonResponse } from 'libraries/service/resources/booking/interfaces/IGetBookings';
import { ProcessingService, ProcessingType } from "libraries/service/processing/processing.service";

@Injectable()
export class BookingProcessingMenuService {

    constructor(
        private readonly processingService: ProcessingService,
        private readonly errorTracingService: ErrorTracingService,
    ) {
    }

    public changePage(action: ProcessingType, bookingSelection: IGetBookingsCommonResponse[], searchParams: any = null): void {

        this.processingService.bookings = bookingSelection;
        this.processingService.searchParams = searchParams && Object.keys(searchParams).filter((param: string) => {
            return param !== 'first' && param !== 'nbrecord' && searchParams[param];
        });
        switch (action) {
            case ProcessingType.SendEmail:
                this.processingService.goToProcessingPage('/sasha/processing-email');
                break;
            case ProcessingType.SendSms:
                this.processingService.goToProcessingPage('/sasha/processing-sms');
                break;
            case ProcessingType.QualityCheck:
                this.processingService.goToProcessingPage('/sasha/processing-qualityCheck/list');
                break;
            case ProcessingType.Issue:
                this.processingService.goToProcessingPage('/sasha/processing-issuing/list');
                break;
            case ProcessingType.Cancel:
                this.processingService.goToProcessingPage('/sasha/processing-cancellation/list');
                break;
            case ProcessingType.Void:
                this.processingService.goToProcessingPage('/sasha/processing-voiding/list');
                break;
            default:
                this.errorTracingService.captureException(`changePage() for ProcessingType "${action}" is not implemented.`);
                break;
        }
    }
}
